.fl_filename_input {
    outline: 1px auto #ddd !important;
}
